// extracted by mini-css-extract-plugin
export default {"melodyCardCategory":"IS-z","categoryName":"JS-z","categoryNameSearchHeader":"KS-z","categoryContent":"LS-z","bottomAligned":"MS-z","image":"NS-z","imageNoBackground":"OS-z"};